import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useService } from '~/services/service.base';
import { AuthService } from '~/services/service.auth';
import { Navigate, useNavigate } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import Cookies from 'js-cookie';
import { EAuthCookies } from '~/shared/types';
export const ProtectedRouteComponent = ({ component, userRoles }) => {
    const authService = useService(AuthService);
    const navigate = useNavigate();
    const autoSignInCookie = Cookies.get(EAuthCookies.autoSignIn);
    const [currentComponent, setCurrentComponent] = useState(null);
    const getResultComponent = useCallback(() => (authService.isUserHasSomeRole(userRoles) ? component : _jsx(Navigate, { to: ROUTES.LOGIN.path })), [authService, component, userRoles]);
    const handleAutoSignIn = useCallback(async (cookieValue) => {
        const autoSignInResponse = await authService.autoSignIn(cookieValue);
        if (autoSignInResponse.data.model?.allow) {
            setCurrentComponent(getResultComponent());
        }
        else {
            throw 'UnAllowed';
        }
    }, [authService, getResultComponent]);
    const initialized = useRef(false);
    useEffect(() => {
        if (initialized.current) {
            return;
        }
        if (!authService.isUserHasSomeRole(userRoles) && autoSignInCookie) {
            handleAutoSignIn(autoSignInCookie).catch(() => navigate(ROUTES.LOGIN.path));
        }
        else {
            setCurrentComponent(getResultComponent());
        }
        initialized.current = true;
    }, [authService, autoSignInCookie, getResultComponent, handleAutoSignIn, navigate, userRoles]);
    return currentComponent;
};
